import React from 'react'
import styles from './AllDriversPanel.module.scss'
import DriverInfoCard from '../../../components/DriverInfoCard/DriverInfoCard'

const AllDriversPanel = ({
  drivers,
  driversPagination,
  driversFilter,
  setDriversFilter,
  loadDriversPage,
  topBases,
  chpps,
  privatePoints,
  topDriversByLoads
}) => {


  const getBaseName = (driver) => {
    if (driver.top_base) {
      const base = topBases?.find(tb => tb.id === driver.top_base)
      return base ? base.name : driver.top_base_name || '-'
    }
    if (driver.chpp) {
      const chpp = chpps?.find(cp => cp.id === driver.chpp)
      return chpp ? chpp.name : driver.chpp_name || '-'
    }
    if (driver.private_point) {
      const pp = privatePoints?.find(p => p.id === driver.private_point)
      return pp ? pp.name : driver.private_point_name || '-'
    }
    return '-'
  }

  React.useEffect(() => {
    const timer = setTimeout(() => {
      loadDriversPage(1, driversFilter)
    }, 300)
    return () => clearTimeout(timer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [driversFilter])

  const handleSearch = () => {
    loadDriversPage(1, driversFilter)
  }

  const getStatusBadge = (status) => {
    if (!status || status === 'Свободен') return <span className={`${styles.badge} ${styles.free}`}>Свободен</span>
    if (status === 'Заблокирован') return <span className={`${styles.badge} ${styles.blocked}`}>{status}</span>
    if (status === 'В пути') return <span className={`${styles.badge} ${styles.route}`}>{status}</span>
    if (status === 'В погрузке') return <span className={`${styles.badge} ${styles.loading}`}>{status}</span>
    return <span className={`${styles.badge} ${styles.loading}`}>{status}</span>
  }

  const rankClass = (i) => {
    if (i === 0) return styles.rank1
    if (i === 1) return styles.rank2
    if (i === 2) return styles.rank3
    return ''
  }

  const [expandedDriver, setExpandedDriver] = React.useState(null)
  const toggleDriver = (id) => setExpandedDriver(prev => prev === id ? null : id)

  return (
    <div className={styles.panel}>
      <div className={styles.header}>
        <h2 className={styles.title}>Водители</h2>
        {driversPagination?.count > 0 && (
          <span className={styles.totalBadge}>Всего: {driversPagination.count}</span>
        )}
      </div>

      {/* Топ 5 */}
      {topDriversByLoads && topDriversByLoads.length > 0 && (
        <div className={styles.topSection}>
          <div className={styles.sectionLabel}>Топ 5 — по количеству погрузок</div>
          <div className={styles.topList}>
            {topDriversByLoads.slice(0, 5).map((driver, i) => (
              <div key={driver.id || i} className={`${styles.topRow} ${rankClass(i)}`}>
                <span className={styles.topRank}>
                  {i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : i + 1}
                </span>
                <span className={styles.topVehicle}>{driver.vehicle_number || '—'}</span>
                <span className={styles.topModel}>{driver.vehicle_model || '—'}</span>
                <div>
                  <div className={styles.topCount}>{driver.loads_count || 0}</div>
                  <div className={styles.topCountSub}>погрузок</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Search */}
      <div className={styles.filtersRow}>
        <input
          className={styles.searchInput}
          placeholder="Поиск по водителю, номеру машины, базе..."
          value={driversFilter}
          onChange={(e) => setDriversFilter(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') handleSearch() }}
        />
      </div>

      {/* Table */}
      {drivers && drivers.length ? (
        <div className={styles.tableWrap}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>№</th>
                <th>Водитель</th>
                <th>Номер машины</th>
                <th>Марка</th>
                <th>База</th>
                <th>Телефон</th>
                <th>Погрузок</th>
                <th>Активность</th>
                <th>Статус</th>
              </tr>
            </thead>
            <tbody>
              {drivers.map((driver, index) => {
                const globalIndex = ((driversPagination?.page || 1) - 1) * 25 + index + 1
                return (
                  <React.Fragment key={driver.id}>
                  <tr
                    style={{ cursor: 'pointer' }}
                    onClick={() => toggleDriver(driver.id)}
                  >
                    <td className={styles.numCell}>{globalIndex}</td>
                    <td className={styles.nameCell}>{driver.employee_name || '—'}</td>
                    <td>{driver.vehicle_number || '—'}</td>
                    <td>{driver.vehicle_model || '—'}</td>
                    <td>{getBaseName(driver)}</td>
                    <td>{driver.employee_phone || driver.phone || '—'}</td>
                    <td className={styles.countCell}>{driver.loads_count || 0}</td>
                    <td>
                      <span className={`${styles.badge} ${driver.is_active ? styles.active : styles.inactive}`}>
                        {driver.is_active ? 'Активен' : 'Неактивен'}
                      </span>
                    </td>
                    <td>{getStatusBadge(driver.status)}</td>
                  </tr>
                  {expandedDriver === driver.id && (
                    <tr>
                      <td colSpan={9} style={{ padding: '12px 16px', background: '#f8fafc' }}>
                        <DriverInfoCard driver={driver} />
                      </td>
                    </tr>
                  )}
                  </React.Fragment>
                )
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <div className={styles.empty}>Водители не найдены</div>
      )}

      {driversPagination?.count > 0 && (
        <div className={styles.pagination}>
          <button className={styles.pageBtn} disabled={!driversPagination.previous}
            onClick={() => loadDriversPage((driversPagination.page || 1) - 1, driversFilter)}>
            Пред.
          </button>
          <span>Стр. {driversPagination.page || 1} из {Math.ceil(driversPagination.count / 25)}</span>
          <button className={styles.pageBtn} disabled={!driversPagination.next}
            onClick={() => loadDriversPage((driversPagination.page || 1) + 1, driversFilter)}>
            След.
          </button>
        </div>
      )}
    </div>
  )
}

export default AllDriversPanel
